import(/* webpackMode: "eager" */ "/home/w3era/w3eraacademy_nextjsapp/src/app/offline-courses/digital-marketing-course/page.tsx");
